<section class="section-main-padding">
    <h1 class="page-title">Refund & Returns Policy</h1>
    <ul>
        <li>All sold products are non-refundable.</li>
        <li>Refund is applicable only for products damaged during shipment or in transit, provided the product is unused
            and in its original packaging.</li>
        <li>No return or exchange is applicable for opened or used products, or if damage is caused to the product after
            delivery.</li>
        <li>Exchange is available within 24 hours of delivery in case of quality issues. To initiate an exchange, write
            to us at <a href="mailto:care&#64;herbslyf.com">care&#64;herbslyf.com</a>.</li>
        <li>Exchange will be accepted only if the product is returned in its original packaging with the original
            receipt and tags intact.</li>
        <li>All returns and exchanges are subject to inspection of the returned shipment.</li>
        <li>Shipping charges are non-refundable.</li>
        <li>Once a return or refund is accepted, it takes 7-21 business days for the refund to be issued.</li>
    </ul>
</section>